<!--
 * @description: 科普标本室  科普文创
 * @Author: Jay
 * @Date: 2021-09-23 10:08:50
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:43:47
-->
<template>
  <div>
    <!-- 标题 -->
    <div v-class="'animate__animated animate__fadeInUp'">
      <div class="text-align padding-xs">
        <p class="font_size_xl text-black font_weight_bold">{{ title }}</p>
        <div class="flex align-center justify-center margin-top-xs">
          <p class="twoTitle margin-right-sm"></p>
          <p class="font_size_lg text-gray">{{ engTitle }}</p>
          <p class="twoTitle margin-left-sm"></p>
        </div>
      </div>
    </div>
    <!-- 轮播顶部区域 -->
    <div
      class="flex align-center justify-between margin-bottom"
      v-class="'animate__animated animate__fadeInUp'"
    >
      <!-- 轮播标题 -->
      <div class="carousel-top padding-sm flex justify-center">
        <ul class="tab-ul" v-for="(item, index) in carouselList" :key="index">
          <li class="font_size_df padding-left-sm" @click="selectTab(index)">
            <span
              class="cuIcon-title text-yellow"
              v-show="tabIndex == index"
            ></span>
            <span class="text-black padding-left-xs">{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <!-- 轮播切换 -->
      <!-- <div class="padding-left font_size_xxl text-black text-right">
        <span class="cuIcon-pullleft"></span>
        <span class="cuIcon-pullright padding-left-sm"></span>
      </div> -->
    </div>
    <!-- 轮播 -->
    <el-carousel
      :interval="4000"
      height="480px"
      arrow="hover"
      indicator-position="none"
      ref="refCarou"
      @change="carChange"
      class="box-shadow"
    >
      <el-carousel-item v-for="(item, index) in carouselList" :key="index">
        <!-- 轮播内容 -->
        <caritem
          :title="title"
          :item="item.product"
          :index="index"
          :tabIndex="tabIndex"
          type="title"
          v-if="item.product != null"
        ></caritem>
        <!-- 内容为空显示 -->
        <div v-else>
          <el-result
            icon="info"
            title="内容为空"
            subTitle="请联系管理员及时更新"
          >
          </el-result>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import caritem from "../../components/carousel/car-item.vue";
export default {
  name: "homeSample",
  props: {
    title: {
      type: String,
      required: true,
    },
    engTitle: {
      type: String,
      required: true,
    },
    carouselList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      //当前选中
      tabIndex: 0,
    };
  },
  components: {
    caritem,
  },
  methods: {
    //切换轮播图
    selectTab(e) {
      //   console.log(e);
      //动态切换
      this.$refs.refCarou.setActiveItem(e);
      this.tabIndex = e;
    },
    //监听轮播图切换
    carChange(e) {
      //   console.log(e);
      this.tabIndex = e;
    },
  },
};
</script>

<style lang="scss" scoped>
//二级标题 左右横线
.twoTitle {
  width: 128px;
  height: 1px;
  background-color: #cccccc;
}
//轮播标题
// .carousel-top {
// width: 100%;
//   background-color: antiquewhite;
// }
</style>